import {Component} from "@angular/core";
import {ServerStatusModel} from "../../framework/bi/server-status/server-status.model";
import {ServerStatus} from "../../framework/bi/server-status/server-status.data";

@Component({
    selector: "wbo-bi-server-status-indicator",
    templateUrl: "./bi-server-status-indicator.component.html",
    styleUrls: ["./bi-server-status-indicator.component.scss"]
})
export class BiServerStatusIndicatorComponent {

    status = ServerStatus;

    constructor(public serverStatusModel: ServerStatusModel) {

    }

}
